document.addEventListener("DOMContentLoaded", function() {

  const popupOverlay = document.getElementById("product-page-popup");
  if (!popupOverlay) return; // stop if popup doesn't exist

  const closeBtn = popupOverlay.querySelector(".popup-close");
  const minimizedBtn = document.getElementById("popup-minimized-btn");

  // Show popup initially
  setTimeout(() => {
    popupOverlay.classList.remove("minimized");
  }, 500);

  // Minimize
  closeBtn.addEventListener("click", function() {
    popupOverlay.classList.add("minimized");
    minimizedBtn.classList.add("active");
  });

  // Restore
  minimizedBtn.addEventListener("click", function() {
    popupOverlay.classList.remove("minimized");
    minimizedBtn.classList.remove("active");
  });

});